import { render, staticRenderFns } from "./subdivisionsAddView.vue?vue&type=template&id=b740dfd6&scoped=true&"
import script from "./subdivisionsAddView.vue?vue&type=script&lang=js&"
export * from "./subdivisionsAddView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b740dfd6",
  null
  
)

export default component.exports